import { render, staticRenderFns } from "./brigad_follow_btn.vue?vue&type=template&id=4f003d13&scoped=true&"
import script from "./brigad_follow_btn.vue?vue&type=script&lang=js&"
export * from "./brigad_follow_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f003d13",
  null
  
)

export default component.exports